"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usersUI = exports.isUserListLoading = exports.isShareLoading = exports.assetIdentities = void 0;
var _actionify = require("@mulesoft/actionify");
var actionTypes = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line import/no-extraneous-dependencies

var usersUI = exports.usersUI = function usersUI(state) {
  return state.users.ui;
};
var assetIdentities = exports.assetIdentities = function assetIdentities(state, _ref) {
  var _state$identities$dat;
  var groupId = _ref.groupId,
    assetId = _ref.assetId;
  return (_state$identities$dat = state.identities.data["".concat(groupId, "/").concat(assetId)]) === null || _state$identities$dat === void 0 ? void 0 : _state$identities$dat.identities;
};
var isShareLoading = exports.isShareLoading = (0, _actionify.createRequestLoadingSelector)(actionTypes.UPDATE_IDENTITIES, function (requestParams, params) {
  return requestParams.groupId === params.groupId && requestParams.assetId === params.assetId;
});
var isUserListLoading = exports.isUserListLoading = (0, _actionify.createRequestLoadingSelector)(actionTypes.GET_IDENTITIES, function (requestParams, params) {
  return requestParams.groupId === params.groupId && requestParams.assetId === params.assetId;
});
//# sourceMappingURL=selectors.js.map